// Checkout URLs for each plan
export const CHECKOUT_URLS = {
  esencial:
    'https://fidelate.com/products/el-costo-de-no-hacer-nada%E2%84%A2-sistema-completo-de-finanzas-personales-para-argentinos-pdf-digital',
  profesional:
    'https://fidelate.com/checkouts/cn/hWNDg1kImoh91DmL2ZMxKrbi/en-ar?_r=AQABowkhdpumBqASvE0ythrmvZn-pmyf2M9KEicBEpLIO5o&preview_theme_id=194856157558',
} as const

export type PlanKey = keyof typeof CHECKOUT_URLS
